var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.autoShow || _vm.show)?_c('i',{class:[
		'download-icon',
		( _obj = {
			'fas fa-question-circle': _vm.download === null,
			'fas fa-circle-notch preparing':
				_vm.download && _vm.download.state === _vm.DownloadState.preparing,
			'fas fa-circle-notch downloading':
				_vm.download && _vm.download.state === _vm.DownloadState.downloading,
			'fas fa-check-circle': _vm.download && _vm.download.state === _vm.DownloadState.downloaded,
			'fas fa-exclamation-circle': _vm.download && _vm.download.state === _vm.DownloadState.failed
		}, _obj[("text-" + (_vm.colors.foreground))] = _vm.autoColor, _obj ) ],attrs:{"role":"status"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }